import React from "react";
import { Image, StyleSheet, TouchableHighlight } from "react-native";
import { colors } from "../../theme";

type Props = {
  icon: "edit" | "filter" | "close";
  onPress: () => void;
  style?: object;
};

const Icon = {
  edit: require(`../../../assets/icons/edit-selected.png`),
  filter: require(`../../../assets/icons/filter.png`),
  close: require(`../../../assets/icons/close.png`),
};

const IconButton: React.FC<Props> = ({ icon, onPress, style = {} }) => {
  return (
    <TouchableHighlight
      onPress={onPress}
      style={[styles.container, style]}
      hitSlop={{ top: 20, bottom: 20, right: 20, left: 20 }}
    >
      <Image source={Icon[icon]} style={styles.icon} />
    </TouchableHighlight>
  );
};

const styles = StyleSheet.create({
  container: {},
  icon: {
    backgroundColor: colors.black,
    width: 24,
    height: 24,
  },
});

export default IconButton;
